import { DEVELOP_MODE } from "@/common/constants/common";

export const DEV_MODE = process.env.BUILD_MODE === DEVELOP_MODE;
export const GATEWAY_URL = process.env.GATEWAY_URL as string;
export const API_ORIGIN = process.env.API_ORIGIN as string;
